import { IconWrapper } from '../runtime';
export default IconWrapper('borderless', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4 14.2497H3.25C2.42157 14.2497 1.75 13.5782 1.75 12.7497V11.9997M12 14.2497H12.75C13.5784 14.2497 14.25 13.5782 14.25 12.7497V11.9997M10 14.2497H6M1.75 3.99973V3.24973C1.75 2.4213 2.42157 1.74973 3.25 1.74973H4M1.75 5.99973V9.99973M14.25 9.99973V5.99973M14.25 3.99973V3.24973C14.25 2.4213 13.5784 1.74973 12.75 1.74973H12M6 1.74973H10M8 7.24973V8.74973M8 5.49973V1.99973M10.5 7.99973H13.5M5.5 7.99973H2M8 10.4997V13.9997",
      "stroke": "#757575",
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});